import * as TYPES from './mutations-types'

export default {
  [TYPES.SET_DASHBOARD_TOTAL_ENROLLMENT_DATA] (state, data) {
    state.totalEnrollmentsData = data
  }
}
